import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../../api/pickupOrderRemote';

import PoAwbList from './PoAwbList';
import PaymentsContainer from '../payments/PaymentsContainer';
import GhaPickupStatusContainer from '../pickupStatus/GhaPickupStatusContainer';

import ApiResponse from '../../../../models/ApiResponse';
import ResponseError from '../../../../models/ResponseError';
import PickupOrderGha from '../../../../models/PickupOrderGha';
import AwbParams from '../../../../models/AwbParams';
import GhaPickupStatus from '../../../../models/GhaPickupStatus';
import { History } from 'history';

import { extractAwbCodeAndNumber } from '../../../../utils/airwayBill';

import poAwbListStyles from './poAwbList.module.css';
import AttachmentsContainer from '../../../attachments/AttachmentsContainer';
import PickupOrderAwb from '../../../../models/PickupOrderAwb';
import Grid from '@material-ui/core/Grid';

import ManualEntryAdd from '../../../../models/ManualEntryAdd';
import { PO_SCHEMA_GHA } from '../../../../utils/pickupOrder';
import { entryAddClearData, entryAddData, entryEditClearData } from '../../../../store/actions/manualEntryEditAction';
import ManualEntryModalContainer from '../manualEntry/ManualEntryModalContainer';
import DriverTruckEdit from '../../../../models/DriverTruckEdit';
import { setAwbAction } from '../../../../store/actions/selectAwbAction';
import User from '../../../../models/User';

interface PoAwbListContainerProps {
  receiveError: Function;
  selectedPoNumber: string;
  selectedAwb: string;
  entryAddData: (manualEntryData: ManualEntryAdd) => void;
  setSelectedAwb: (awbNumber: string) => void;
  entryAddClearData: () => void;
  manualEntryEditClearData: () => void;
  history: History;
  selectedAwbNumber: string;
  selectedAwbCode: string;
  setAwbAction: (number: string, changed: boolean) => void;
  changed: boolean;
  openCloseEditAwbs: Function;
  user: User;
};

interface PoAwbListContainerState {
  awbs: Array<PickupOrderAwb>;
  awbCode: string;
  awbNumber: string;
  awbVer: number;
  prevSelectedAwbCode: string;
  prevSelectedAwbNumber: string;
  prevSelectedAwbVer: number;
  poNumb: string;
  due: boolean;
  weightAwb: number;
  updateLocations: boolean;
  updateCustomsClearance: boolean;
  openModalManualEntry: boolean;
  isAttachmentsDialogOpen: boolean;
  selectedDrvTrkData: DriverTruckEdit;
  po: PickupOrderGha;
};

class PoAwbListContainer extends Component<PoAwbListContainerProps, PoAwbListContainerState> {

  state: PoAwbListContainerState = {
    awbs: [],
    awbCode: '',
    awbNumber: '',
    awbVer: 0,
    prevSelectedAwbCode: '',
    prevSelectedAwbNumber: '',
    prevSelectedAwbVer: 0,
    poNumb: '',
    due: false,
    weightAwb: 0,
    updateLocations: false,
    updateCustomsClearance: false,
    isAttachmentsDialogOpen: false,
    openModalManualEntry: false,
    po: PO_SCHEMA_GHA,
    selectedDrvTrkData: {
      orderNumber: '',
      delivery_company_name: '',
      delivery_company_name_new: '',
      driver_id: '',
      driver_id_type: '',
      driver_name: '',
      driver_vehichle_registration: '',
      rfs_number: ''
    }
  }

  componentDidMount(): void {

    if (this.props.selectedPoNumber && this.props.selectedPoNumber !== '-1') {
      this.loadAwbs();
      this.loadPoOrderAwbs(this.props.selectedPoNumber);
    }
  }

  componentDidUpdate(prevProps: PoAwbListContainerProps): void {

    if (this.props.selectedPoNumber !== prevProps.selectedPoNumber && this.props.selectedPoNumber !== '-1') {

      this.setState({
        awbs: [],
        awbCode: '',
        awbNumber: '',
        awbVer: 0,
        prevSelectedAwbCode: '',
        prevSelectedAwbNumber: '',
        prevSelectedAwbVer: 0
      }, () => {
        this.loadAwbsForPickupOrder(this.props.selectedPoNumber);
        this.loadPoOrderAwbs(this.props.selectedPoNumber);
      });
    }
    if (this.props.changed !== prevProps.changed && this.props.changed) {
      setTimeout(() => {
        this.changeAwb(`${this.props.selectedAwbCode}-${this.props.selectedAwbNumber}`, 1);
        const elementIndex = this.state.awbs.findIndex((awb) => awb.number == this.props.selectedAwbNumber);
        this.scrollRow(elementIndex);
      }, 500);
    }
  }

  scrollRow = (rowIndex: number = 11) => {
    const table = document.getElementById('myTable');
    if (table) {
      const rows = table.getElementsByTagName('tr');
      if (rowIndex >= 0 && rowIndex < rows.length) {
        rows[rowIndex].scrollIntoView({ behavior: 'smooth' });
      }
      const table2 = document.getElementsByClassName('MuiTableBody-root');
    }
  }

  loadAwbs = (): void => {

    if (this.props.selectedPoNumber && this.props.selectedPoNumber !== '-1') {
      this.loadAwbsForPickupOrder(this.props.selectedPoNumber);
    }
  }

  loadAwbsForPickupOrder = (poNumber: string): void => {
    this.setState({ poNumb: poNumber }, () => {
      pickupOrderRemote.getGhaPickupOrderList(poNumber).then((resp: ApiResponse<PickupOrderGha>) => {

        const po: PickupOrderGha | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (po) {

          const awbs: Array<PickupOrderAwb> = po.list;
          if (awbs.length) {
            let awbCode: string;
            let awbNumber: string;
            let awbVer: number;
            const awbCurrent: string = awbs[0].code + '-' + awbs[0].number;
            const awbPrevious: string = (this.state.prevSelectedAwbCode && this.state.prevSelectedAwbNumber) ? (this.state.prevSelectedAwbCode + '-' + this.state.prevSelectedAwbNumber) : '';

            if (awbPrevious && awbCurrent !== awbPrevious) {

              awbCode = this.state.prevSelectedAwbCode;
              awbNumber = this.state.prevSelectedAwbNumber;
              awbVer = this.state.prevSelectedAwbVer

            } else {
              awbCode = awbs[0].code;
              awbNumber = awbs[0].number;
              awbVer = awbs[0].version;
            }

            const updateLocations: boolean = po.allowed_ops ? po.allowed_ops.update_wh_locations : false;
            const updateCustomsClearance: boolean = po.allowed_ops ? po.allowed_ops.update_customs_clearance : false;

            this.props.setSelectedAwb(`${awbCode}-${awbNumber}-${awbVer}`);

            this.handleCommonResponsePayed(poNumber, awbCode, awbNumber, awbVer);

            this.setState({
              awbs,
              awbCode,
              awbNumber,
              awbVer,
              updateLocations,
              updateCustomsClearance
            });
          }

        }

        if (error) {
          this.props.receiveError(error);
        }
      });
    });


  }

  loadPoOrderAwbs = (dooNumber: string): void => {

    pickupOrderRemote.getGhaPickupOrderList(dooNumber).then((resp: ApiResponse<PickupOrderGha>) => {

      const po: PickupOrderGha | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (po) {
        this.setState({ po });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  handleCloseModalManualEntry = (isUpdated?: boolean): void => {
    this.props.entryAddClearData();
    this.setState({ openModalManualEntry: false });
  }

  handleAwbChange = (event: React.ChangeEvent<HTMLInputElement>, version: number): void => {
    const selectedAwbCodeNumber: string = event.target.value;
    this.changeAwb(selectedAwbCodeNumber, version);
  }
  changeAwb = (selectedAwbCodeNumber: string, version: number): void => {
    const awbParams: AwbParams = extractAwbCodeAndNumber(selectedAwbCodeNumber);

    this.setState({
      awbCode: awbParams.awbCode,
      awbNumber: awbParams.awbNumber,
      prevSelectedAwbCode: awbParams.awbCode,
      prevSelectedAwbNumber: awbParams.awbNumber,
      prevSelectedAwbVer: version,
      isAttachmentsDialogOpen: false,
      awbVer: version
    });
    // this.props.setAwbAction(selectedAwbCodeNumber, false);
    this.props.setSelectedAwb(selectedAwbCodeNumber);
    this.handleCommonResponsePayed(this.props.selectedPoNumber, awbParams.awbCode, awbParams.awbNumber, version);
  }

  handleOpenManualEntryEdit = (): void => {
    this.props.manualEntryEditClearData();
    const data = this.state.po;
    const manualEntryEditData: ManualEntryAdd = {
      isAddMode: true,
      driverData: {
        driverId: data.driver_id || '',
        driverIdType: data.driver_id_type || '',
        name: data.driver_name || '',
        company: data.delivery_company_name || '',
        truckPlateNumber: data.driver_vehichle_registration || '',
        driverTime: data.driver_checkin_time,
        rfsNumber: data.rfs_number || ''
      },
      forwarderId: data.id_forwarder,
      dockId: data.id_dock || -1,
      orderNumber: data.number,
      isInterline: data.forwarder_company_info.type === "interline" ? true : false,
      isRfs: data.rfs_number ? true : false,
      orderId: data.id
    };

    this.setState({ openModalManualEntry: true });
    this.props.entryAddData(manualEntryEditData);
  }

  handleCommonResponsePayed = (poNumber: string, awbCode: string, awbNumber: string, ver: number): void => {

    pickupOrderRemote.getGhaPoAwb(poNumber, awbCode, awbNumber, ver).then((resp: ApiResponse<GhaPickupStatus>) => {

      const status: GhaPickupStatus | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (status) {

        const due: boolean = status.due;
        this.setState({ due });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  // openDialog pattern is used for better consistency with `DooAwbListContainer` even though only one type of dialog exists
  openDialog = (type: string, awbCode: string, awbNumber: string): void => {

    if (this.state.awbCode === awbCode && this.state.awbNumber === awbNumber) {
      switch (type) {
        case 'attachments': this.setState({ isAttachmentsDialogOpen: true });
          break;
      }
    }
  }

  closeDialog = (type: string): void => {

    switch (type) {
      case 'attachments':
        this.setState({ isAttachmentsDialogOpen: false });
        this.loadAwbs();
        break;
    }
  }

  setWeight = (weight: string): void => {

    const weightAwb = +(weight);
    this.setState({ weightAwb });
  }

  render() {

    const selectedAwbCodeNumber = `${this.state.awbCode}-${this.state.awbNumber}-${this.state.awbVer}`;

    return (

      <div className={poAwbListStyles.maindiv}>
        <PoAwbList
          awbs={this.state.awbs}
          selectedAwbCode={this.state.awbCode}
          selectedAwbNumber={this.state.awbNumber}
          handleChange={this.handleAwbChange}
          openDialog={this.openDialog}
          addAwb={this.handleOpenManualEntryEdit}
          po={this.state.po}
          changed={this.props.changed}
          openCloseEditAwbs={this.props.openCloseEditAwbs}
          user={this.props.user}
        />
        {this.props.selectedPoNumber && this.props.selectedPoNumber !== '-1' && this.state.awbCode && this.state.awbNumber &&

          <div className={[poAwbListStyles.displayFlex, poAwbListStyles.mainWrapper].join(' ')} >
            <Grid container direction="row" className={poAwbListStyles.poContainer} >
              <Grid item lg={6} md={6} sm={12} className={poAwbListStyles.poGridItem} >
                <GhaPickupStatusContainer
                  poNumber={this.state.poNumb}
                  awbCodeNumber={selectedAwbCodeNumber}
                  due={this.state.due}
                  setWeight={this.setWeight}
                  updateLocations={this.state.updateLocations}
                  updateCustomsClearance={this.state.updateCustomsClearance}
                  triggerAwbsUpdate={this.loadAwbs}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} className={poAwbListStyles.poGridItem}>
                <PaymentsContainer
                  selectedPoNumber={this.props.selectedPoNumber}
                  awbNo={selectedAwbCodeNumber}
                  handleCommonResponsePayed={this.handleCommonResponsePayed}
                  weight={this.state.weightAwb}
                  triggerAwbsUpdate={this.loadAwbs}
                  awbVer={this.state.awbVer}
                />
              </Grid>
            </Grid>
          </div>
        }
        {this.state.isAttachmentsDialogOpen &&
          <AttachmentsContainer
            code={this.state.awbCode}
            number={this.state.awbNumber}
            version={this.state.awbVer}
            process={'import'}
            closeAttachments={() => this.closeDialog('attachments')}
            refreshAwbs={false}
            orderNumber={this.state.poNumb}
          />
        }
        {this.state.openModalManualEntry &&
          <ManualEntryModalContainer
            type={'po'}
            history={this.props.history}
            modalOpen={this.state.openModalManualEntry}
            handleCloseModal={this.handleCloseModalManualEntry}
            driverData={{
              name: this.state.selectedDrvTrkData.driver_name,
              company: this.state.selectedDrvTrkData.delivery_company_name,
              check_in: null
            }}
          />
        }
      </div>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    selectedAwbCode: state.selectAwb.selectedAwbCode,
    selectedAwbNumber: state.selectAwb.selectedAwbNumber,
    changed: state.selectAwb.changed,
    user: state.user
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    manualEntryEditClearData: () => dispatch(entryEditClearData()),
    entryAddData: (manualEntryData: ManualEntryAdd) => dispatch(entryAddData(manualEntryData)),
    entryAddClearData: () => dispatch(entryAddClearData()),
    setAwbAction: (awbNumber: string, changed: boolean) => dispatch(setAwbAction(awbNumber, changed))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PoAwbListContainer);